<template>
  <div class="container">
    <app-header title="集成电路"/>
    <van-search v-model="value" @search="gotoSearchProduct" placeholder="请输入搜索关键词" />
    <!-- 分类 -->
    <div  style="overflow: hidden">
      <div class="tabs row">
        <div class="tab" v-text="item.name" v-for="(item,index) in tabList" :key="index" :class="[item.id==activeTag?'active':'']" @click="handleTag(item)"></div>
      </div>
    </div>
    <div style="border:1px solid rgba(199,199,199,1);"></div>
    <!-- 推荐商品 -->
    <Goods :productList="productList"/>

  </div>
</template>

<script>
import Goods from './modules/Goods'
import { getShopCategoryList } from '@/api/category'
import { getShopProductList } from '@/api/product'
export default {
  name: 'Index',
  components: {
    Goods
  },
  data() {
    return {
      value: '',
      activeTag: 0,
      productList: [],
      tabList: []
    }
  },
  created() {
    this.getTab()
  },
  methods: {
    getTab() {
      getShopCategoryList({ type: 0, pid: 0 }).then(res => {
        if (res.success) {
          this.tabList = res.data
          if (this.tabList) {
            this.activeTag = this.tabList[0].id
            this.getProduct(this.activeTag)
          }
        }
      })
    },
    getProduct(cid) {
      getShopProductList({ type: 0, parentId: cid }).then(res => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate(url) {
      this.$router.push({
        path: url
      })
    },
    handleTag(item) {
      this.activeTag = item.id
      this.getProduct(item.id)
    },
    gotoSearchProduct() {
      if (this.value == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      line-height: 44px;
      padding: 0 12px;
      overflow-x: scroll;
      -webkit-backface-visibility: hidden;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      .tab {
        height:25px;
        line-height: 25px;
        padding: 0 0.4rem;
        white-space: nowrap;
        font-size: 16px;
        font-weight:bold;
        cursor: pointer;
        &.active {
          color: #FE003B;
          border-bottom: 3px solid #FE003B;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/navChild.vue